import { render, staticRenderFns } from "./DailyComparisonCard.vue?vue&type=template&id=67d683ec"
import script from "./DailyComparisonCard.vue?vue&type=script&lang=js"
export * from "./DailyComparisonCard.vue?vue&type=script&lang=js"
import style0 from "./DailyComparisonCard.vue?vue&type=style&index=0&id=67d683ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports